import Functions from '@client/style/Functions';
import { presetColors } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import React from 'react';
import styled from 'styled-components';
import { useIsFavourite } from '../Favourites/FavouriteStore';
import Link, { createLinkObject } from '@client/core/PageSwitch/Link';
import { FavouritePanelCompact } from '../Favourites/FavouritePanelCompact';

const Event = styled.div<{ $start: number; $duration?: number }>`
	grid-column-start: ${props => Math.round(props.$start * 4)};
	grid-column-end: span
		${props => {
			if (!props.$duration || props.$duration === 0) return 3;
			return Math.round(Math.max(props.$duration * 4, 2)) - 1;
		}};
	align-self: start;
	margin-bottom: 5px;
`;

const LinkContainer = styled(Link)<{ $favourite: boolean }>`
	width: fit-content;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: start;
	color: ${props => (props.$favourite ? presetColors.white : presetColors.blackish)};

	border-left: 4px solid currentColor;
	padding-left: 14px;
`;

const EventTitle = styled.p`
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p6')}
	line-height: 1.1;

	${Functions.limitText(1)};
`;

const EventTime = styled.p`
	${TextStyle.family('title')}
	${TextStyle.size('xsmall')}
	line-height: 1.2;
`;

const FavContainer = styled.div`
	padding-top: 4px;
`;

interface IProps {
	data: any;
	start: number;
	duration?: number;
}

export default function SpilleplanEvent(props: IProps) {
	const isFavourite = useIsFavourite(props.data.id);

	return (
		<Event $start={props.start} $duration={props.duration}>
			<LinkContainer data={createLinkObject(props.data)} $favourite={isFavourite}>
				<EventTitle>{props.data.title}</EventTitle>
				<EventTime>
					{new Date(props.data.startTime).toLocaleTimeString('Da-dk', {
						hour: '2-digit',
						minute: '2-digit',
						timeZone: 'Europe/Copenhagen',
					})}
				</EventTime>
				<FavContainer>
					<FavouritePanelCompact size={22} artistId={props.data.id} />
				</FavContainer>
			</LinkContainer>
		</Event>
	);
}
